export const dashHome = {
  index: {
    boxes: {
      reservas: "Prenotazioni",
      checkins: "Check-in",
      ocupacion: "Occupazione",
      facturacion: "Fatturato",
      ingresosTotal: "Ricavi totali",
      saldos: "Saldi in sospeso",
      solicitudes: "Richieste AI",
      facturas: "Fatture in sospeso",
      acciones: "Azioni in sospeso",
      salen: "In partenza oggi",
      llegadas: "Prossimi arrivi",
      ingresosDesglose: "Dettaglio dei ricavi",
    },
    editToolbar: {
      done: "Fatto",
      addBox: "Aggiungi riquadro",
      reset: "Reimposta",
      hint: "Trascina per spostare · tira l'angolo per ridimensionare",
      allBoxesVisible: "Tutti i riquadri sono visibili.",
      removeTitle: "Rimuovi",
      showOnboarding: "Mostra l'avviso di configurazione",
    },
  },
  arrivals: {
    viewAll: "Visualizza tutti gli arrivi",
  },
  todayLeaving: {
    title: "Ospiti in partenza oggi",
    subtitle: "Check-out previsti per oggi.",
    empty: "Nessun ospite in partenza oggi.",
    loading: "Caricamento dei check-out di oggi…",
    balance: "Saldo",
    balanceDueTitle: "Saldo dovuto: {amount} {currency}",
    paid: "Pagato",
    paidTitle: "Prenotazione pagata",
    viewAll: "Visualizza tutti i check-out",
  },
  mobileNotice: {
    sheetAriaLabel: "Scarica l'app WACheckin",
    closeAriaLabel: "Chiudi",
    title: "Sfrutta al massimo WACheckin",
    desc: "Il pannello è progettato per <b>desktop</b>. Su mobile hai una sintesi; per gestire <b>tutte le funzionalità</b> comodamente, aprilo sul computer o scarica la nostra <b>app</b>.",
    appStorePrefix: "Scarica su",
    googlePlayPrefix: "Disponibile su",
    continueOnMobile: "Continua a visualizzare su mobile",
  },
};
